import { nip19 } from 'nostr-tools';
import { useParams } from 'react-router-dom';
import { KIND_MAGAZINE, KIND_EBOOK, KIND_MAGAZINE_ISSUE } from '@/lib/pressstrKinds';
import { MagazinePage } from './MagazinePage';
import { EbookPage } from './EbookPage';
import { IssuePage } from './IssuePage';
import { ProfilePage } from './ProfilePage';
import NotFound from './NotFound';

export function NIP19Page() {
  const { nip19: identifier } = useParams<{ nip19: string }>();

  if (!identifier) {
    return <NotFound />;
  }

  let decoded;
  try {
    decoded = nip19.decode(identifier);
  } catch {
    return <NotFound />;
  }

  const { type } = decoded;

  switch (type) {
    case 'npub':
      return <ProfilePage pubkey={decoded.data} />;

    case 'nprofile':
      return <ProfilePage pubkey={decoded.data.pubkey} />;

    case 'naddr': {
      const { kind, pubkey, identifier: dTag } = decoded.data;
      if (kind === KIND_MAGAZINE) {
        return <MagazinePage pubkey={pubkey} identifier={dTag} />;
      }
      if (kind === KIND_EBOOK) {
        return <EbookPage pubkey={pubkey} identifier={dTag} />;
      }
      if (kind === KIND_MAGAZINE_ISSUE) {
        return <IssuePage pubkey={pubkey} identifier={dTag} />;
      }
      return <NotFound />;
    }

    default:
      return <NotFound />;
  }
}
